import React from 'react';
import { default as __ } from '../../../utils';

import Login from './login';
import SignUp from './signup';

const AuthScreens = ({ defaultOpen = true }) => {

  const [currentIsOpen, currentSetOpen] = __.useControllableProp({
    updater: onToggle,
    defaultValue: defaultOpen,
  });

  function onToggle() { currentSetOpen(!currentIsOpen) };

  return (
    <>
      <br/>
      <div className='row-center align-center '>
        {currentIsOpen ? <button className='io-unbutton txt-uppercase pill-button' type="button"
            onClick={()=>onToggle()}>  
            Go to log in
            </button> :  <button className='io-unbutton txt-uppercase pill-button' type="button"
            onClick={()=>onToggle()}>Go to sign up</button>
          }
      </div>
      <div className="small-container">
        {currentIsOpen ? <SignUp /> : <Login />}
      </div>

    </>
  );
};

export default AuthScreens;
